import { render } from "./headerlogo1.vue?vue&type=template&id=0126e416"
import script from "./headerlogo1.vue?vue&type=script&lang=js"
export * from "./headerlogo1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__